import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgPaid(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="6 0 12 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.6 20v-1.832c2.435-.224 4.083-1.589 4.083-3.626v-.037c0-2-1.246-3.122-4.16-3.832V7.084c.882.187 1.764.617 2.608 1.215l1.073-1.757c-1.073-.766-2.224-1.252-3.604-1.42V4h-1.668v1.084c-2.396.206-4.025 1.57-4.025 3.57v.038c0 2.112 1.303 3.121 4.102 3.831v3.683c-1.246-.206-2.281-.767-3.374-1.645L7.409 16.28a8.964 8.964 0 004.524 1.85V20h1.668zm-1.591-9.72c-1.476-.448-1.84-.953-1.84-1.738v-.019c0-.822.613-1.439 1.84-1.551v3.308zm1.514 6v-3.4c1.477.43 1.898.934 1.898 1.757v.037c0 .897-.67 1.477-1.898 1.607z"
      />
    </svg>
  );
}

export default tombacIcon('Paid')(SvgPaid);
